import {
  Box,
  CircularProgress,
  Skeleton,
  Stack,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EmbeddedLoadingProps {
  applicationName: string;
}

export function EmbeddedLoading({ applicationName }: EmbeddedLoadingProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Box
      role="status"
      aria-live="polite"
      aria-label={t('embedded.embeddedLoadingLabel', { application: applicationName })}
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'background.default',
        p: 3,
      }}
    >
      <CircularProgress size={36} aria-hidden />
      <Stack spacing={1} alignItems="center" sx={{ width: '100%', maxWidth: 360 }}>
        <Typography variant="subtitle1">
          {applicationName}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('embedded.embeddedLoadingMessage')}
        </Typography>
        <Skeleton variant="rounded" width="100%" height={12} />
        <Skeleton variant="rounded" width="80%" height={12} />
        <Skeleton variant="rounded" width="65%" height={12} />
      </Stack>
    </Box>
  );
}
